(() => {
  const amount = value => {
    const number = Number(String(value || '').replace(/[^0-9.\-]/g, ''));
    return Number.isFinite(number) ? Math.round(number * 100) : 0;
  };
  function feeFor(subtotal, fees) {
    let total = 0;
    for (const fee of fees) {
      const logic = fee.logic || {};
      const restricted = ['products', 'collections', 'conditions', 'customer_tags', 'locations', 'markets', 'payment_methods'];
      if (fee.price_type !== 'fixed' || logic.fee_type !== 'order' || restricted.some(key => logic[key]?.length) || logic.quantities?.conditions?.length || logic.appliedTo?.[0] !== 'subtotal' || logic.appliedDisjunctively?.[0] === 'true' || !logic.cart?.length) return null;
      if (logic.cart.some(rule => rule.column !== 'cart_subtotal' || !['lessthan', 'greaterthan', 'equals', 'greaterthanorequal', 'lessthanorequal'].includes(rule.relation))) return null;
      const applies = logic.cart.every(rule => {
        const threshold = amount(rule.condition);
        if (rule.relation === 'lessthan') return subtotal < threshold;
        if (rule.relation === 'greaterthan') return subtotal > threshold;
        if (rule.relation === 'greaterthanorequal') return subtotal >= threshold;
        if (rule.relation === 'lessthanorequal') return subtotal <= threshold;
        return subtotal === threshold;
      });
      if (applies) total += Math.round(Number(fee.price));
    }
    return total;
  }
  function unitPrice(base, quantity, tiers) {
    let price = base;
    for (const tier of tiers) if (quantity >= tier.minimum) price = tier.percent == null ? tier.price : Math.round(base * (1 - tier.percent / 100));
    return price;
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = {amount, feeFor, unitPrice};
  if (typeof document === 'undefined') return;
  function initialise(summary) {
    if (summary.dataset.ready) return;
    summary.dataset.ready = 'true';
    const root = summary.closest('.sa-award-page');
    const form = summary.closest('form');
    if (!root || !form) return;
    const config = JSON.parse(summary.querySelector('.sa-price-summary-config').textContent);
    const product = JSON.parse(root.querySelector('.sa-award-config').textContent);
    const text = config.text;
    let cart = config.cart;
    let cartFresh = false;
    let feeConfig;
    let refreshTimer;
    let announcementTimer;
    let lastAnnouncement = '';
    const dialog = summary.querySelector('dialog');
    const format = value => new Intl.NumberFormat('en-AU', {style:'currency',currency:cart.currency || config.currency}).format(value / 100);
    const setText = (element, value) => { if (element && element.textContent !== value) element.textContent = value; };
    const setValue = (name, value) => setText(summary.querySelector('[data-price-value="' + name + '"]'), value);
    const row = (name, show) => {const el=summary.querySelector('[data-price-row="' + name + '"]'); if(el && el.hidden === show) el.hidden = !show;};
    const substitute = (message, values) => Object.entries(values).reduce((out, [key, value]) => out.replaceAll('[' + key + ']', value), message);
    const loadFees = () => {
      if (feeConfig) return feeConfig;
      for (const script of document.querySelectorAll('script[type="application/json"]')) {
        if (!script.textContent.includes('"fees_metaobjects"')) continue;
        try {
          const data = JSON.parse(script.textContent);
          if (Array.isArray(data.fees_metaobjects)) {feeConfig=data; return data;}
        } catch {}
      }
      return null;
    };
    function rules() {
      const data=loadFees();
      const fees=data?.fees_metaobjects;
      const container=summary.querySelector('[data-fee-rules]');
      if (!fees || feeFor(0,fees) === null || config.currency !== 'AUD') {setText(container,text.fee_unknown);return;}
      if (container.dataset.complete) return;
      container.replaceChildren();
      for (const fee of [...fees].sort((a,b)=>Math.max(...a.logic.cart.map(c=>amount(c.condition)))-Math.max(...b.logic.cart.map(c=>amount(c.condition))))) {
        const line=document.createElement('div');
        const label=document.createElement('span');
        const price=document.createElement('strong');
        label.textContent=[...fee.logic.cart].sort((a,b)=>a.relation==='greaterthan'?-1:b.relation==='greaterthan'?1:0).map(condition=>substitute(text[condition.relation],{amount:format(amount(condition.condition))})).join(' ' + text.and + ' ');
        price.textContent=format(Math.round(Number(fee.price)));
        line.append(label,price);container.append(line);
      }
      const line=document.createElement('div');const label=document.createElement('span');const price=document.createElement('strong');
      label.textContent=text.other_ranges;price.textContent=format(0);line.append(label,price);container.append(line);
      container.dataset.complete='true';
    }
    function update() {
      const variant=product.variants.find(v=>String(v.id)===String(form.querySelector('[name="id"]')?.value));
      if (!variant) return;
      const quantity=Math.max(1,Math.floor(Number(form.querySelector('[name="quantity"]')?.value)||1));
      const tiers=Array.from(root.querySelectorAll('.hulkapps-table tbody tr')).map(tr=>{
        const minimum=Number(tr.querySelector('td')?.textContent.match(/\d+/)?.[0]);
        const price=tr.querySelector('.hulkapps-price')?.textContent.trim();
        return {minimum,price:amount(price),percent:price?.includes('%')?Number(price.match(/[\d.]+/)?.[0]):null};
      }).filter(t=>t.minimum>0 && (t.price>0 || t.percent!=null)).sort((a,b)=>a.minimum-b.minimum);
      const base=Number(variant.price);
      const discounted=unitPrice(base,quantity,tiers);
      const discount=Math.max(0,base-discounted)*quantity;
      const optionTotal=root.querySelector('#option_total');
      const options=optionTotal && getComputedStyle(optionTotal).display!=='none' ? amount(optionTotal.querySelector('#formatted_option_total')?.textContent)*quantity : 0;
      let box;
      if (root.querySelector('.sa-tray-box-input')?.checked) box=product.trayBoxes?.find(b=>String(b.trayId)===String(variant.id));
      if (root.querySelector('.sa-glass-box-input')?.checked) box=product.glassBoxes?.find(b=>String(b.glassId)===String(variant.id));
      const flask=root.querySelector('.sa-flask-box-input:checked')?.value;
      if (flask) box=product.flaskBoxes?.find(b=>String(b.flaskId)===String(variant.id)&&String(b.id)===flask);
      if (root.dataset.saBoxVariant) box=product.boxes?.find(b=>String(b.id)===root.dataset.saBoxVariant);
      const boxes=Number(box?.price||0)*quantity;
      const app=loadFees();
      const feeIds=new Set([app?.order_fees_placeholder?.variant_id,app?.product_fees_placeholder?.variant_id,...(app?.fees_metaobjects||[]).map(f=>f.id)].filter(Boolean).map(String));
      const items=(cart.items||[]).filter(item=>!feeIds.has(String(item.variant_id)) && !['order-fees','additional-fees'].includes(item.handle));
      const existing=items.reduce((sum,item)=>sum+Number(item.final_line_price ?? item.line_price ?? 0),0);
      const subtotal=existing+discounted*quantity+options+boxes;
      const fee=cartFresh && app && config.currency==='AUD' && !app.disable_storefront_fee_application ? feeFor(subtotal,app.fees_metaobjects) : null;
      setText(summary.querySelector('[data-price-label="product"]'),config.title+' × '+quantity);
      setValue('product',format(base*quantity));
      row('discount',discount>0);setValue('discount','−'+format(discount));
      row('options',options>0);setValue('options',format(options));
      row('box',boxes>0);setText(summary.querySelector('[data-price-label="box"]'),(box?.title||text.box)+' × '+quantity);setValue('box',format(boxes));
      row('existing',items.length>0);setValue('existing',format(existing));
      setValue('fee',fee==null?text.fee_unknown:format(fee));
      const totalLabel=config.taxesIncluded?(items.length?text.basket_total:text.total):(items.length?text.basket_subtotal:text.subtotal);
      setText(summary.querySelector('[data-price-label="total"]'),totalLabel);
      setValue('total',format(subtotal+(fee||0)));
      const note=(fee==null?text.unknown_note:items.length?text.basket_note:text.note)+(config.taxesIncluded?'':' '+text.tax_note);
      setText(summary.querySelector('[data-price-note]'),note);
      setText(summary.querySelector('[data-fee-current]'),fee==null?text.fee_unknown:substitute(text.current_fee,{subtotal:format(subtotal),fee:format(fee)}));
      rules();
      const announcement=totalLabel+' '+format(subtotal+(fee||0))+'. '+text.fee+' '+(fee==null?text.fee_unknown:format(fee));
      if (announcement!==lastAnnouncement) {clearTimeout(announcementTimer);announcementTimer=setTimeout(()=>{setText(summary.querySelector('[data-price-announcement]'),announcement);lastAnnouncement=announcement;},350);}
    }
    async function refresh() {
      try {
        const response=await fetch((window.Shopify?.routes?.root||'/')+'cart.js',{headers:{Accept:'application/json'},cache:'no-store'});
        if (!response.ok) throw new Error('cart');
        cart=await response.json();cartFresh=true;
      } catch {cartFresh=false;}
      update();
    }
    const refreshSoon=()=>{clearTimeout(refreshTimer);refreshTimer=setTimeout(refresh,450);};
    summary.querySelector('.sa-fee-info').addEventListener('click',()=>{update();dialog.showModal();});
    summary.querySelectorAll('.sa-fee-close,.sa-fee-done').forEach(button=>button.addEventListener('click',()=>dialog.close()));
    dialog.addEventListener('click',event=>{if(event.target===dialog){const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();}});
    root.addEventListener('input',update);
    root.addEventListener('change',()=>{update();setTimeout(update,100);});
    let scheduled=false;
    new MutationObserver(mutations=>{
      if (!mutations.some(m=>!summary.contains(m.target))) return;
      if(scheduled)return;scheduled=true;requestAnimationFrame(()=>{scheduled=false;update();});
    }).observe(root,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['value','class','style','data-sa-box-variant']});
    ['on:cart:add','on:line-item:change','cart:updated'].forEach(name=>document.addEventListener(name,refreshSoon));
    new MutationObserver(changes=>{
      if(changes.some(change=>{
        const element=change.target.nodeType===1?change.target:change.target.parentElement;
        return element?.closest('.supercart-drawer,cart-drawer,#cart-icon') || Array.from(change.addedNodes).some(node=>node.nodeType===1 && node.matches('.supercart-drawer,cart-drawer'));
      })) refreshSoon();
    }).observe(document.body,{subtree:true,childList:true,characterData:true});
    window.addEventListener('focus',refreshSoon);
    window.addEventListener('pageshow',refreshSoon);
    document.addEventListener('visibilitychange',()=>{if(!document.hidden)refreshSoon();});
    update();refresh();
    setTimeout(update,1500);
  }
  const init=()=>document.querySelectorAll('.sa-price-summary').forEach(initialise);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();
